import React, {useEffect, useState, useRef} from 'react';

import {
    Box,
    Breadcrumbs,
    Divider,
    Link,
    Stack,
    Typography,
    Paper,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    InputAdornment,
    IconButton,
    List,
    ListSubheader,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    ListItem,
    Chip,
    Skeleton,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    Grid,
    styled,
    FormHelperText,
    Checkbox,
    Card,
    Tooltip
} from '@mui/material';

import * as Yup from "yup";
import dayjs from "dayjs";

import {
    LoadingButton
} from '@mui/lab';

import {useFormik} from 'formik';

import {CommonIcons, icons} from '../common/CommonIcons';

import {useSystemPrompt} from '../../hooks/useSystemPrompt';
import {useDocuments, documentTypes, targetTypes} from '../../hooks/api/useDocuments';
import {useRegions, regionTypes} from '../../hooks/api/useRegions';

import {useDataGridParams} from '../../hooks/useDataGridParams';
import {useSystemRoutes} from '../../hooks/useSystemRoutes';
import {useTranslations} from "../../hooks/useTranslations";

import DataGridTable from '../common/DataGridTable';
import DataGridToolbar from '../common/DataGridToolbar';

import DatePickerComponent from '../common/DatePickerComponent';

import {useAppContextFeatures} from '../../context/AppContext';

// import { checkValueExists } from '../../utils/dataSchema'

import {spliceString} from '../../utils/formatString';

const StyledIcon = styled(Box)(({theme}) => ({
    width: 20,
    height: 20,
    // opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledTitle = styled(Box)(({theme}) => ({
    fontWeight: 800,
    fontSize: '1.0rem'
}))

const StyledSubTitle = styled(Box)(({theme}) => ({
    fontWeight: 300,
    fontSize: '0.8rem'
}))

const filterDocumentTypes = [
    {
        id: 'deliveryOrder',
        name: "Delivery Order",
        value: documentTypes.deliveryOrder
    },
    {
        id: 'itemTransfer',
        name: "Item Transfer",
        value: documentTypes.itemTransfer
    },
    {
        id: 'cashSales',
        name: "Cash Sales",
        value: documentTypes.cashSales
    },
    {
        id: 'replacementDelivery',
        name: "Replacement Delivery",
        value: documentTypes.replacementDelivery
    }
]

// const validationSelectionSchema = Yup.object({
//     documentType: Yup
//         .string()
//         .required("Required"),
//     documentId: Yup
//         .string()
//         .required("Required"),
//     documentNumber: Yup
//         .string()
//         .required("Required"),
//     documentDate: Yup
//         .string()
//         .required("Required"),
//     address: Yup
//         .string()
//         .required("Required"),
//     countryName: Yup
//         .string()
//         .required("Required"),
//     stateName: Yup
//         .string()
//         .required("Required"),
//     areaName: Yup
//         .string()
//         .required("Required"),
// })

const validationSchema = Yup.object({
    documentType: Yup
        .mixed()
        .oneOf(filterDocumentTypes.map(i => i.value))
        .required('Required'),
    locationId: Yup
        .string()
        .required("Required"),
    // selection: Yup.array().of(validationSelectionSchema),
    // dateFrom: Yup
    //     .date("Invalid")
    //     .required("Required")
    //     .typeError("Invalid"),
    // dateTo: Yup
    //     .date("Invalid")
    //     .required("Required")
    //     .typeError("Invalid")
})

// export const initialSelectionValues = {
//     documentType: "",
//     documentId: "",
//     documentNumber: "",
//     documentDate: "",
//     address: "",
//     countryName: "",
//     stateName: "",
//     areaName: "",
// }

export const initialValues = {
    documentType: "",
    profileName: "",
    locationId: "",
    dateFrom: "",// dayjs(),
    dateTo: "",// dayjs(),
    countryId: "",
    stateId: "",
    areaId: "",
    // selection: []
}

const StyledCard = styled(Card)(({theme}) => ({
    padding: theme.spacing(2)
}));

const RenderToolbar = ({t, selectedIds, selectedDatas, handleSelect}) => {

    const getToolbarMainMenus = () => {

        let props = [];

        // adding the new button
        props.push({
            displayIconName: icons.documents,
            displayText: `${t('confirmSelection')} (${selectedDatas.length})`,
            onClick: () => {

                handleSelect()
                // navigate(getRoute("documents/deliveryOrder/generateFromContainer"));

            }
        })

        return props
    }

    const getActionOnClick = () => {

        // let handleFunction = null

        // if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
        //     handleFunction = handleDelete
        // }

        // return handleFunction
    }

    const getActionMenus = () => {
        return []
    }

    return (
        <DataGridToolbar
            selectedRowCount={
                selectedIds.length
            }
            mainMenus={
                getToolbarMainMenus()
            }
            actionOnClickRemove={
                getActionOnClick()
            }
            actionMenus={
                getActionMenus()
            }
        />
    )
}

const RenderDataGridTable = ({
                                 gridRef,
                                 refreshDataGrid,
                                 fetchData,
                                 columns,
                                 filterValues,
                                 onSelectionChange
                             }) => {

    return (
        <DataGridTable
            ref={gridRef}
            refresh={refreshDataGrid}
            fetchData={fetchData}
            dataGrid={{
                idProperty: "id",
                style: {
                    minHeight: 600
                },
                pageSizes: [20, 50, 100],
                defaultLimit: 10,
                defaultSkip: 0,
                checkboxColumn:
                    true,
                columns,
                defaultFilterValue: filterValues,
                skipAllSearch: true,
                onSelectionChange
                // onSelectionChange: (items, data) => {
                //     console.log('items selected : ', items, data)
                //     setSelectedIds(
                //         items
                //     )
                //     setSelectedDatas(
                //         data
                //     )
                // }
            }}

        />
    )

}

const RenderResults = ({
                           t,
                           selectedIds,
                           selectedDatas, handleSelect, gridRef,
                           refreshDataGrid,
                           fetchData,
                           columns,
                           filterValues,
                           onSelectionChange
                       }) => {
    return (
        <StyledCard
            sx={{
                p: 0
            }}
        >
            <RenderToolbar
                t={t}
                selectedIds={selectedIds}
                selectedDatas={selectedDatas}
                handleSelect={handleSelect}
            />
            <RenderDataGridTable
                gridRef={gridRef}
                refreshDataGrid={refreshDataGrid}
                fetchData={fetchData}
                columns={columns}
                filterValues={filterValues}
                onSelectionChange={onSelectionChange}
            />

        </StyledCard>
    )
}

const RenderDialog = ({
                          typeRef,
                          showDataTable,
                          handleExit,
                          config,
                          open,
                          t,
                          selectedIds,
                          selectedDatas,
                          handleSelect,
                          gridRef,
                          refreshDataGrid,
                          fetchData,
                          columns,
                          filterValues,
                          onSelectionChange,
                          keyword,
                          searchInputRef,
                          filterDocumentTypes,
                          formik,
                          dataRegions,
                          onChangeCountry,
                          onChangeState,
                          onChangeArea,
                          onChangeSearch,
                          onReset
                      }) => {
    return (
        <Dialog
            sx={{
                '& .MuiDialog-paper':
                    {
                        // width: '80%',
                        // minHeight: '95vh'
                    }
            }}
            fullWidth={Boolean(true)}
            maxWidth="xl"
            // TransitionProps={{ onEntering: handleEntering }}
            open={open}
            // {...other}
            onClose={handleExit}
            scroll={"body"}
        >
            <DialogTitle
            >
                {
                    config?.dialogDisplayText ? config.dialogDisplayText : `Search Pick Order Documents`
                }

                <IconButton
                    aria-label="close"
                    onClick={handleExit}
                    sx={{
                        position: 'absolute',
                        right: 10,
                        top: 10,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CommonIcons name={icons.cancel}/>
                </IconButton>

            </DialogTitle>
            <DialogContent
                // dividers
                // minHeight="100%"
                sx={{
                    // backgroundColor: 'red',
                    pl: 0,
                    pr: 0,
                    pt: 0
                }}
            >
                {/* {JSON.stringify(errors)} */}


                {/* {JSON.stringify(values?.selection)} */}
                <RenderList
                    t={t}
                    typeRef={typeRef}
                    showDataTable={showDataTable}
                    selectedIds={selectedIds}
                    selectedDatas={selectedDatas}
                    handleSelect={handleSelect}
                    gridRef={gridRef}
                    refreshDataGrid={refreshDataGrid}
                    fetchData={fetchData}
                    columns={columns}
                    filterValues={filterValues}
                    onSelectionChange={onSelectionChange}
                    keyword={keyword}
                    searchInputRef={searchInputRef}
                    filterDocumentTypes={filterDocumentTypes}
                    formik={formik}
                    dataRegions={dataRegions}
                    onChangeCountry={onChangeCountry}
                    onChangeState={onChangeState}
                    onChangeArea={onChangeArea}
                    onChangeSearch={onChangeSearch}
                    onReset={onReset}
                />

            </DialogContent>
            {/* <DialogActions>
                    <Button
                        autoFocus
                        // onClick={handleCancel}
                        onClick={() => {
                            handleOnCancel()
                        }}
                    >Cancel</Button>
                    <Button
                        // onClick={handleOk}
                        onClick={() => {
                            handleOnConfirm()
                        }}
                    >Ok</Button>
                </DialogActions> */}
        </Dialog>
    )
}

const RenderList = ({
                        t,
                        typeRef,
                        showDataTable,
                        selectedIds,
                        selectedDatas,
                        handleSelect,
                        gridRef,
                        refreshDataGrid,
                        fetchData,
                        columns,
                        filterValues,
                        onSelectionChange,
                        keyword,
                        searchInputRef,
                        filterDocumentTypes,
                        formik,
                        dataRegions,
                        onChangeCountry,
                        onChangeState,
                        onChangeArea,
                        onChangeSearch,
                        onReset
                    }) => {

    const {handleSubmit} = formik

    return (
        <Box
            sx={{
                px: 2
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} md={3} sm={12}>

                    {/* {JSON.stringify(errors)} */}
                    {/* {JSON.stringify(errors)} */}

                    <form onSubmit={handleSubmit}>
                        <RenderListHeader
                            t={t}
                            typeRef={typeRef}
                            keyword={keyword}
                            searchInputRef={searchInputRef}
                            filterDocumentTypes={filterDocumentTypes}
                            formik={formik}
                            dataRegions={dataRegions}
                            onChangeCountry={onChangeCountry}
                            onChangeState={onChangeState}
                            onChangeArea={onChangeArea}
                            onChangeSearch={onChangeSearch}
                            onReset={onReset}
                        />
                    </form>
                </Grid>
                <Grid item xs={12} md={9} sm={12}>

                    {

                        showDataTable &&
                        <RenderResults
                            t={t}
                            selectedIds={selectedIds}
                            selectedDatas={selectedDatas}
                            handleSelect={handleSelect}
                            gridRef={gridRef}
                            refreshDataGrid={refreshDataGrid}
                            fetchData={fetchData}
                            columns={columns}
                            filterValues={filterValues}
                            onSelectionChange={onSelectionChange}
                        />
                    }

                </Grid>
            </Grid>
        </Box>
    )
}

const RenderListHeader = ({
                              t, typeRef, keyword, searchInputRef,
                              filterDocumentTypes, formik,
                              dataRegions, onChangeCountry, onChangeState,
                              onChangeArea, onChangeSearch, onReset
                          }) => {


    const {values, errors, touched, setFieldValue, handleChange} = formik

    return (

        <Paper
            elevation={3}
            sx={{
                p: 2,
                // display: 'flex',
                // flexDirection: 'row',
                // justifyContent: 'space-between',
                // alignItems: 'center'
            }}
        >
            <Grid container columnSpacing={1}>
                <Grid item sm={12} xs={12} md={12}>
                    <FormControl
                        margin="dense"
                        fullWidth
                        size="small"
                        error={touched.documentType && Boolean(errors.documentType)}
                    >
                        <InputLabel id="documentType">{t('documentType')}</InputLabel>
                        <Select
                            inputRef={typeRef}
                            labelId="documentType"
                            label={t('documentType')}
                            name={"documentType"}
                            onChange={(event) => {
                                // setDocumentType(event.target.value)
                                setFieldValue(`documentType`, event.target.value)
                            }}
                            value={values.documentType}
                            sx={{
                                textAlign: 'left'
                            }}
                        >
                            {
                                filterDocumentTypes.map((i, index) => {
                                    return (
                                        <MenuItem key={index} value={i.value}>{i.name}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                        <FormHelperText>
                            {touched.documentType && errors.documentType}
                        </FormHelperText>
                    </FormControl>
                </Grid>


                <Grid item sm={12} xs={12} md={12}>

                    <FormControl
                        margin="dense"
                        fullWidth
                        size="small"
                        error={touched.countryId && Boolean(errors.countryId)}
                    >
                        <InputLabel id="countryId">{t('country')}</InputLabel>
                        <Select

                            labelId="countryId"
                            label={t('country')}
                            name={"countryId"}
                            onChange={onChangeCountry}
                            // onChange={
                            //     async (event) => {
                            //         setFieldValue("countryId", event.target.value)
                            //
                            //         // fetch for the states
                            //         await fetchRegions({regionType: regionTypes.state, countryId: event.target.value})
                            //         setFieldValue(`stateId`, "")
                            //         setFieldValue(`areaId`, "")
                            //     }
                            // }
                            value={values.countryId}
                        >

                            {
                                dataRegions?.country.map((i, index) => {
                                    return (
                                        <MenuItem key={index} value={i.id}>{i.country_name}</MenuItem>
                                    )
                                })
                            }

                        </Select>
                        <FormHelperText>
                            {touched.countryId && errors.countryId}
                        </FormHelperText>
                    </FormControl>

                </Grid>

                <Grid item sm={12} xs={12} md={12}>

                    <FormControl
                        margin="dense"
                        fullWidth
                        size="small"
                        error={touched.stateId && Boolean(errors.stateId)}
                    >
                        <InputLabel id="stateId">{t('state')}</InputLabel>
                        <Select

                            labelId="stateId"
                            label={t('state')}
                            name={"stateId"}
                            onChange={onChangeState}
                            // onChange={
                            //     async (event) => {
                            //         setFieldValue("stateId", event.target.value)
                            //
                            //         // fetch for the states
                            //         await fetchRegions({regionType: regionTypes.area, stateId: event.target.value})
                            //         setFieldValue(`areaId`, "")
                            //     }
                            // }
                            value={values.stateId}
                        >

                            {
                                dataRegions?.state.map((i, index) => {
                                    return (
                                        <MenuItem key={index} value={i.id}>{i.state_name}</MenuItem>
                                    )
                                })
                            }

                        </Select>
                        <FormHelperText>
                            {touched.stateId && errors.stateId}
                        </FormHelperText>
                    </FormControl>

                </Grid>

                <Grid item sm={12} xs={12} md={12}>

                    <FormControl
                        margin="dense"
                        fullWidth
                        size="small"
                        error={touched.areaId && Boolean(errors.areaId)}
                    >
                        <InputLabel id="areaId">{t('area')}</InputLabel>
                        <Select

                            labelId="areaId"
                            label="Area"
                            name={t('area')}
                            onChange={onChangeArea}
                            // onChange={
                            //     (event) => {
                            //         setFieldValue("areaId", event.target.value)
                            //     }
                            // }
                            value={values.areaId}
                        >

                            {
                                dataRegions?.area.map((i, index) => {
                                    return (
                                        <MenuItem key={index} value={i.id}>{i.area_name}</MenuItem>
                                    )
                                })
                            }

                        </Select>
                        <FormHelperText>
                            {touched.areaId && errors.areaId}
                        </FormHelperText>
                    </FormControl>

                </Grid>

                <Grid item sm={12} xs={12} md={12}>
                    <TextField
                        inputRef={searchInputRef}
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        label={t("searchDocumentNo")}
                        fullWidth
                        variant="outlined"
                        onChange={onChangeSearch}
                        // onChange={e => {
                        //     setKeyword(e.target.value)
                        // }}
                        value={keyword}
                        InputProps={{
                            startAdornment:
                                <InputAdornment position="start">
                                    <CommonIcons name={icons.search}/>
                                </InputAdornment>
                        }}
                    />
                </Grid>

                <Grid item sm={12} xs={12} md={12}>
                    <TextField
                        // inputRef={searchInputRef}
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        label={t("profileName")}
                        fullWidth
                        variant="outlined"
                        onChange={e => {
                            // setKeyword(e.target.value)
                            setFieldValue(`profileName`, e.target.value)
                        }}
                        value={values?.profileName ? values.profileName : ""}
                        // InputProps={{
                        //     startAdornment:
                        //         <InputAdornment position="start">
                        //             <CommonIcons name={icons.search} />
                        //         </InputAdornment>
                        // }}
                    />
                </Grid>

                <Grid item sm={12} xs={12} md={12}>
                    <DatePickerComponent
                        config={{
                            name: "dateFrom",
                            label: t("documentDateFrom")
                        }}
                        formik={{
                            values,
                            errors,
                            touched,
                            handleChange,
                            setFieldValue
                        }}
                        sx={{
                            width: '100%'
                        }}
                    />
                </Grid>
                <Grid item sm={12} xs={12} md={12}>
                    <DatePickerComponent
                        config={{
                            name: "dateTo",
                            label: t("documentDateTo")
                        }}
                        formik={{
                            values,
                            errors,
                            touched,
                            handleChange,
                            setFieldValue
                        }}
                        sx={{
                            width: '100%'
                        }}
                    />
                </Grid>
                <Grid item sm={6} xs={6} md={6}>
                    <Button
                        type='button'
                        variant='outlined'
                        color={"primary"}
                        fullWidth
                        size='medium'
                        sx={{
                            mt: 1
                        }}
                        onClick={onReset}
                        // onClick={() => {
                        //     setFieldValue(initialValues)
                        //     // setRefreshDataGrid(refreshDataGrid + 1)
                        //     setShowDataTable(false)
                        // }}
                    >
                        {t('reset')}
                    </Button>
                </Grid>
                <Grid item sm={6} xs={6} md={6}>
                    <Button
                        type='submit'
                        variant='contained'
                        color="primary"
                        fullWidth
                        size='medium'
                        sx={{
                            mt: 1
                        }}
                    >
                        {t('search')}
                    </Button>
                </Grid>
            </Grid>

        </Paper>
    )
}


export default function SearchPickDocuments(
    {
        routeType,
        id,
        locationId,
        config,
        // customDisplay,
        handleOnCancel,
        handleOnSelect,
        handleOnSearchChange,
        textProps
    }
) {
    const {t} = useTranslations({ns: ["common", "prompt", "@document"]})

    const gridRef = useRef();
    const searchInputRef = useRef()
    const typeRef = useRef()

    const [open, setOpen] = useState(false)
    const [keyword, setKeyword] = useState(config?.filterKeyword ? config.filterKeyword : "")
    const [data, setData] = useState([])
    const [selectedIds, setSelectedIds] = useState([])
    const [selectedDatas, setSelectedDatas] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)

    // const [ document, setDocument ] = useState()
    const {list: listRegions} = useRegions({regionType: regionTypes.country})

    // const [ documentType, seƒDocumentType ] = useState(config?.filterDocumentType? config.filterDocumentType : "")

    const {defineColumns, hideDefaultColumns, columns, filterValues, getRenderColumnLink, getRenderColumnTextDisplay} = useDataGridParams('id')

    const {getRoute} = useSystemRoutes(routeType);

    const {promptMessage} = useSystemPrompt()
    const {isLoading, list: listDocuments, get, filterOperatorTypes} = useDocuments({
        documentType: '',
        targetType: '',
        customEndpoint: 'get_by_action/pick_order/pick_order_filter_documents'
    });

    const {setSystemLoading} = useAppContextFeatures()

    const [showDataTable, setShowDataTable] = useState(false)

    const [dataRegions, setDataRegions] = useState({
        country: [],
        state: [],
        area: []
    })

    const getRegionName = ({regionType, id}) => {

        let selected = [];

        if (regionType === regionTypes.country) {
            selected = dataRegions.country.filter(i => i.id === id)
            return selected.length > 0 ? selected[0].country_name : ""
        }
        if (regionType === regionTypes.state) {
            selected = dataRegions.state.filter(i => i.id === id)
            return selected.length > 0 ? selected[0].state_name : ""
        }
        if (regionType === regionTypes.area) {
            selected = dataRegions.area.filter(i => i.id === id)
            return selected.length > 0 ? selected[0].area_name : ""
        }

        return ""

    }

    const fetchRegions = async ({regionType, countryId, stateId}) => {

        try {

            let props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "country_name",
                    dir: 0,
                },
                // filterValue: filterValues
            }

            props.regionType = regionType

            if (regionType === regionTypes.state) {
                props.countryId = countryId
                props.sortInfo = {
                    id: "state_name",
                    dir: 0,
                }
            }

            if (regionType === regionTypes.area) {
                props.stateId = stateId
                props.sortInfo = {
                    id: "area_name",
                    dir: 0,
                }
            }

            let response = await listRegions(props);
            // console.log('response?.data?.items', response?.data?.items)

            if (regionType === regionTypes.country) {
                setDataRegions({
                    ...dataRegions,
                    country: response?.data?.countries ? response?.data?.countries : [],
                    state: [],
                    area: []
                })
            }

            if (regionType === regionTypes.state) {
                setDataRegions({
                    ...dataRegions,
                    // country: response?.data?.countries? response?.data?.countries : [],
                    state: response?.data?.states ? response?.data?.states : [],
                    area: []
                })
            }

            if (regionType === regionTypes.area) {
                setDataRegions({
                    ...dataRegions,
                    // country: response?.data?.countries? response?.data?.countries : [],
                    // state: response?.data?.states? response?.data?.states : [],
                    area: response?.data?.areas ? response?.data?.areas : [],
                })
            }


        } catch (error) {
            promptMessage(false, `${error.message}`)
        }
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: () => {


            setShowDataTable(true)
            setRefreshDataGrid(refreshDataGrid + 1)
        }
    });

    const {
        handleSubmit,
        handleChange,
        values,
        errors,
        touched,
        setFieldValue
    } = formik;

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
        setSelectedDatas([])
    }

    const getDefaultFilterValues = () => {

        let filterValues = []

        filterValues.push({
            name: "location_id",
            operator: filterOperatorTypes.eq,
            value: locationId,
        })

        if (values?.documentType) {
            filterValues.push({
                name: "type",
                operator: filterOperatorTypes.eq,
                value: values?.documentType.toUpperCase(),
            })
        }

        // build filters
        if (keyword) {
            filterValues.push({
                name: "doc_number",
                operator: filterOperatorTypes.contains,
                value: keyword,
                group: "name_group"
            })
            // filterValues.push({
            //     name: "delivery_profile_name",
            //     operator: filterOperatorTypes.contains,
            //     value: keyword,
            //     group: "name_group"
            // })
        }

        if (values?.profileName) {
            filterValues.push({
                name: "delivery_profile_name",
                operator: filterOperatorTypes.contains,
                value: values?.profileName,
                group: "name_group"
            })
        }

        if (values?.dateFrom) {
            filterValues.push({
                name: "doc_date",
                operator: filterOperatorTypes.moreThanEq,
                value: values.dateFrom,
                group: "name_group"
            })
        }

        if (values?.dateTo) {
            filterValues.push({
                name: "doc_date",
                operator: filterOperatorTypes.lessThanEq,
                value: values.dateTo,
                group: "name_group"
            })
        }

        if (values?.countryId) {

            // if(documentType === documentTypes.deliveryOrder){
            filterValues.push({
                name: "delivery_country",
                operator: filterOperatorTypes.eq,
                value: getRegionName({regionType: regionTypes.country, id: values.countryId}),
                group: "name_group"
            })
            // }

        }

        if (values?.stateId) {

            filterValues.push({
                name: "delivery_state_id",
                operator: filterOperatorTypes.eq,
                value: values.stateId,
                group: "name_group"
            })

        }

        if (values?.areaId) {

            filterValues.push({
                name: "delivery_area_id",
                operator: filterOperatorTypes.eq,
                value: values.areaId,
                group: "name_group"
            })

        }

        return filterValues
    }

    const onSelectionChange = (items, data) => {
        console.log('items selected : ', items, data)
        setSelectedIds(
            items
        )
        setSelectedDatas(
            data
        )
    }

    const fetchData = async (props) => {

        // resetDataGridTableSelection();

        try {
            // props.customFilterLocationEnable = true;
            // props.customFilterLocationFields = ['location_id']
            // props.dataTypes = ["delivery_injection_props"]

            // mandatory
            props.filterValue = getDefaultFilterValues()

            console.log('props', props)

            const result = await listDocuments(props)

            console.log('result', result)

            return {
                data: result?.data?.documents,
                count: result?.data?.total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }

    }

    useEffect(() => {

        setData([])

        setFieldValue(`locationId`, locationId)

        fetchRegions({regionType: regionTypes.country})

    }, [])

    useEffect(() => {

        setData([])

    }, [values?.documentType])

    useEffect(() => {
        hideDefaultColumns(true)
        defineColumnsView()
    }, [])

    useEffect(() => {

        const timeout = setTimeout(() => {

            if (open) {
                // searchInputRef?.current.focus();
                typeRef?.current.focus();
                // console.log('serachRef', searchInputRef?.current)
            }

        }, 100);

        return () => {
            clearTimeout(timeout);
        };

    }, [open])


    const defineColumnsView = () => {

        defineColumns([
            {
                name: 'location_name', header: t('location')
            },
            // {
            //     name: 'type',
            //     header: 'Type',
            //     renderValue: ({ value, cellProps }) => {

            //         // let path = getRoute(`documents/deliveryOrder/view/${cellProps.data.id}`);

            //         return value

            //     }
            // },
            {
                name: 'doc_number',
                header: t('docNo'),
                renderValue: ({value, cellProps}) => {

                    let path = '';

                    if (cellProps.data.type.toLowerCase() === documentTypes.deliveryOrder.toLowerCase()) {
                        path = getRoute(`documents/deliveryOrder/view/${cellProps.data.id}`);
                    }

                    if (cellProps.data.type.toLowerCase() === documentTypes.itemTransfer.toLowerCase()) {
                        path = getRoute(`documents/itemTransfer/view/${cellProps.data.id}`);
                    }

                    if (cellProps.data.type.toLowerCase() === documentTypes.cashSales.toLowerCase()) {
                        path = getRoute(`documents/cashSales/view/${cellProps.data.id}`);
                    }

                    if (cellProps.data.type.toLowerCase() === documentTypes.replacementDelivery.toLowerCase()) {
                        path = getRoute(`documents/replacementDelivery/view/${cellProps.data.id}`);
                    }

                    // return getRenderColumnLink(path, value)

                    return (
                        <Link
                            href={path}
                            target='_blank'
                        >
                            {value}
                        </Link>
                    )

                }
            },
            {
                name: 'doc_date', header: t('date')
            },
            {
                name: 'delivery_profile_name',
                header: t('profile'),
                renderValue: ({value, cellProps}) => {

                    let displayValue = `${cellProps.data.delivery_profile_name}`

                    return (
                        <Box
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"flex-start"}
                            alignItems={"center"}
                        >
                            <Tooltip
                                title={
                                    displayValue
                                }
                                placement="right"
                            >
                                <Typography>
                                    {`${spliceString({val: displayValue, maxLength: 10})}`}
                                </Typography>

                            </Tooltip>

                        </Box>
                    )

                }
            },
            {
                name: 'delivery_address_1',
                header: t('address'),
                renderValue: ({value, cellProps}) => {

                    let displayValue = `${cellProps.data.delivery_address_1}, ${cellProps.data.delivery_address_2}`

                    return (
                        <Box
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"flex-start"}
                            alignItems={"center"}
                        >
                            <Tooltip
                                title={
                                    displayValue
                                }
                                placement="right"
                            >
                                <Typography>
                                    {`${spliceString({val: displayValue, maxLength: 10})}`}
                                </Typography>

                            </Tooltip>

                        </Box>
                    )

                }
            },
            {
                name: 'delivery_state',
                header: t('state'),
                renderValue: ({value, cellProps}) => {

                    // let displayValue = `${cellProps.data.delivery_address_1}, ${cellProps.data.delivery_address_2}`

                    return value

                }
            },
            {
                name: 'delivery_area',
                header: t('area'),
                renderValue: ({value, cellProps}) => {

                    // let displayValue = `${cellProps.data.delivery_address_1}, ${cellProps.data.delivery_address_2}`

                    return value

                }
            }
        ])

    }

    const RenderListDataItemSkeleton = () => {
        return (
            <>
                <Skeleton
                    animation="wave"
                    // variant="circular"
                    sx={{
                        minWidth: 100,
                        mr: 1,
                        height: 50
                    }}
                />
                <ListItemText
                    // fullWidth
                    // height={50}
                >
                    <Skeleton
                        variant="rectangular"
                        width={"100%"}
                        height={20}
                    />
                    <Skeleton
                        variant="rectangular"
                        width={"100%"}
                        height={20}
                        sx={{
                            mt: 1
                        }}
                    />
                </ListItemText>
            </>
        )
    }

    const RenderListDataItemDisplay = ({item}) => {

        return (
            <>
                <Grid container padding={1}>
                    <Grid item md={1} textAlign={"center"}>
                        <CommonIcons name={icons.documents} sx={{width: 40, height: 40}}/>
                    </Grid>
                    <Grid item md={9}>
                        <Box
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            flexGrow={1}
                            sx={{}}
                        >
                            <StyledTitle sx={{textTransform: 'uppercase'}}>
                                {`${item?.delivery_profile_name}`}
                            </StyledTitle>
                            <Box
                                display={"flex"}
                                flexDirection={"row"}
                                justifyContent={"space-between"}
                                alignItems={"center"}
                                sx={{
                                    ml: 1
                                }}
                            >
                                <Chip
                                    label={`${item?.delivery_state ? item.delivery_state : '-'}`}
                                    size='small'
                                    variant='outlined'
                                    color="primary"
                                />
                                <Chip
                                    label={`${item?.delivery_area ? item.delivery_area : '-'}`}
                                    size='small'
                                    variant='outlined'
                                    color="primary"
                                    sx={{ml: 1}}
                                />
                            </Box>
                        </Box>
                        <StyledSubTitle>
                            {`${item?.delivery_address_1}`} {`${item?.delivery_address_2}`} {`${item?.delivery_postcode}`}
                        </StyledSubTitle>


                        {/* <StyledSubTitle>
                            {`${item?.delivery_contact}`} {`${item?.delivery_email}`}
                        </StyledSubTitle> */}
                    </Grid>
                    <Grid item md={2} textAlign={"right"}>
                        <StyledTitle>
                            {`${item?.doc_number}`}
                        </StyledTitle>
                        <StyledSubTitle>
                            {`${item?.doc_date}`}
                        </StyledSubTitle>
                    </Grid>
                </Grid>
            </>
        )

    }

    // const RenderListDataItem = ({ isLoading = false, index, item }) => {
    //     return (
    //         <ListItem
    //             key={index}
    //             divider
    //             disablePadding
    //         >
    //             <ListItemButton
    //                 role={undefined}
    //                 // onClick={() => {
    //                 //     handleSelect({ id: item?.id, item });
    //                 // }}
    //                 dense
    //             >
    //                 <Grid container>
    //                     <Grid item xs={1}>
    //                         <Checkbox
    //                             // checked={
    //                             //     Boolean(itemValues?.selected)
    //                             // }
    //                             // disabled={
    //                             //     item?.deliveryOrder?.enableCheckbox === false
    //                             // }
    //                             // name={`selection.${index}.selected`}
    //                             // value={Boolean(true)}
    //                             onChange={(e) => {
    //                                 // let val = e.target.checked
    //                                 // setFieldValue(`documents.${index}.selected`, (val))
    //                             }}
    //                         // {...label}
    //                         />
    //                     </Grid>
    //                     <Grid item xs={11}>
    //                         {
    //                             Boolean(isLoading) ? <RenderListDataItemSkeleton /> : <RenderListDataItemDisplay item={item} />
    //                         }
    //                     </Grid>
    //                 </Grid>


    //             </ListItemButton>
    //         </ListItem>
    //     )
    // }


    const handleExit = () => {
        setOpen(false);

        if (handleOnCancel)
            handleOnCancel();
    }

    const handleSelect = async () => {

        if (selectedIds.length <= 0) {
            promptMessage(false, `Please select at least (1) document`)
            return false
        }

        // let document = await fetchAllDocument({
        //     id,
        //     documentType
        // })

        console.log('selectedDatas', selectedDatas)

        if (handleOnSelect)
            handleOnSelect({ids: selectedIds, items: selectedDatas})

        // console.log('handleOnSelect', handleOnSelect)

        // promptMessage(true, `Selected (1) item`)
        setOpen(false);

        return true;
    }

    const RenderSearch = () => {

        // check the custom display is set
        // if(customDisplay){
        //     return customDisplay({setOpen})
        // }

        return (
            <TextField
                disabled={textProps?.disabled ? textProps.disabled : false}
                margin="dense"
                size="small"
                fullWidth
                name={id}
                label={t("documentNumber")}
                type="text"
                variant="outlined"
                value={textProps?.value ? textProps.value : ""}
                onChange={(val) => handleOnSearchChange(val)}
                error={textProps?.error ? textProps.error : false}
                helperText={textProps?.helperText}
                InputProps={{
                    style: {
                        paddingRight: 5
                    },
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                disabled={!Boolean(locationId)}
                                aria-label="open"
                                onClick={() => setOpen(true)}
                            >
                                <CommonIcons name={icons.search}/>
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        )
    }

    return (
        <Box>
            <RenderSearch/>

            <RenderDialog
                t={t}
                typeRef={typeRef}
                showDataTable={showDataTable}
                open={open}
                config={config}
                handleExit={handleExit}
                selectedIds={selectedIds}
                selectedDatas={selectedDatas}
                handleSelect={handleSelect}
                gridRef={gridRef}
                refreshDataGrid={refreshDataGrid}
                fetchData={fetchData}
                columns={columns}
                filterValues={filterValues}
                onSelectionChange={onSelectionChange}
                keyword={keyword}
                searchInputRef={searchInputRef}
                filterDocumentTypes={filterDocumentTypes}
                formik={formik}
                dataRegions={dataRegions}
                onChangeCountry={async (event) => {
                    setFieldValue("countryId", event.target.value)

                    // fetch for the states
                    await fetchRegions({regionType: regionTypes.state, countryId: event.target.value})
                    setFieldValue(`stateId`, "")
                    setFieldValue(`areaId`, "")
                }}
                onChangeState={async (event) => {
                    setFieldValue("stateId", event.target.value)

                    // fetch for the states
                    await fetchRegions({regionType: regionTypes.area, stateId: event.target.value})
                    setFieldValue(`areaId`, "")
                }}
                onChangeArea={(event) => {
                    setFieldValue("areaId", event.target.value)
                }}
                onChangeSearch={e => {
                    setKeyword(e.target.value)
                }}
                onReset={() => {
                    setFieldValue(initialValues)
                    // setRefreshDataGrid(refreshDataGrid + 1)
                    setShowDataTable(false)
                }}
            />
        </Box>
    )
}